import * as React from 'react'

import {
  Box,
  IconButton,
  Avatar,
  Typography,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
} from '@mui/material'

import NotificationsIcon from '@mui/icons-material/Notifications';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';

import { CMenuList } from '../common/MenuList';

import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../slices/auth';

function Sidebar(props) {
  const user = useSelector(state => state.auth.user);
  const {first_name, last_name, username, role} = user;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleAccount = (e) => {
    setAnchorEl(e.currentTarget);
  }

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    dispatch(logout());
    navigate('/');
  }

  return (
    <Box className='w-full flex flex-row justify-between align-center'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
        >
        <Typography sx={{fontSize: 20, fontWeight: 600}} className='color-black'>Hello, {username}</Typography>
        <Typography sx={{fontSize: 14}} className='color-gray'>Have a nice day</Typography>
      </Box>
      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
      }}>
        <Box sx={{
          borderRight: 1, 
          borderColor: 'divider',
          paddingRight: '12px'
        }}>
          <IconButton aria-label="notification">
            <NotificationsIcon />
          </IconButton>
        </Box>
        <Box 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            textAlign: 'center', 
            marginLeft: '12px',
            gap: 1.5, 
            ':hover': {
              cursor: 'pointer'
            } 
          }}
          onClick={handleAccount}
        >
          <Avatar sx={{ width: 45, height: 45 }}>J</Avatar>
          <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
            <Typography sx={{fontSize: 16, fontWeight: 600}} className='color-black'>{first_name} {last_name}</Typography>
            <Typography sx={{fontSize: 12}} className='color-black'>{role}</Typography>
          </Box>
          <KeyboardArrowDownIcon />
        </Box>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <CMenuList dense>
          <MenuItem onClick={handleClose}>
            <ListItemIcon>
              <PersonAdd fontSize="small" />
            </ListItemIcon>
            My Account
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleClose}>
            <ListItemIcon>
              <Settings fontSize="small" />
            </ListItemIcon>
            Settings
          </MenuItem>
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </CMenuList>
      </Menu>
    </Box>
  )
}

export default Sidebar;